import { FETCH_DISCOUNT_AMOUNT } from '../constants';

const discountAmount = (state = 0, action) => {
  switch (action.type) {
    case FETCH_DISCOUNT_AMOUNT:
      return action.payload;
    default:
      return state;
  }
};

export default discountAmount;
